import { LocationHistoryRequest, LocationHistoryResponse, LocationHistoryResult } from "../app/shared/models/layout/location/history/LocationHistory";

export function response(params: LocationHistoryRequest): LocationHistoryResponse {
    return {
        cmd: {
            success: true,
            params: {
                sampling: null,
                values: result
            }
        }
    }
}

let result: LocationHistoryResult[] = [
    {
        id: '1',
        thingId: '1',
        ts: '2020-10-01T01:22:04.504Z',
        duration: 0,
        corrId: '1',
        lat: 32.126048,
        lng: 34.838504,
        fixAcc: 0,
        fixType: 'network',
        heading: 0,
        altitude: 0,
        speed: 0,
        delta: 0,
        address: {
            streetNumber: "9",
            street: "Sderot HaShoshanim",
            city: "Tel Aviv-Yafo",
            state: "Tel Aviv District",
            zipCode: "6962343",
            country: "IL"
        }
    },
    {
        id: '2',
        thingId: '1',
        ts: '2020-10-01T01:22:04.504Z',
        duration: 0,
        corrId: '1',
        lat: 32.126048,
        lng: 35,
        fixAcc: 0,
        fixType: 'network',
        heading: 0,
        altitude: 0,
        speed: 0,
        delta: 0,
        address:{
            "streetNumber": "125",
            "street": "Delawanna Avenue",
            "city": "Clifton",
            "state": "New Jersey",
            "zipCode": "07014",
            "country": "US"
        }

    }
]
